window.currentLocale = function () {
    return window.$('meta[name="locale"]').attr('content');
};
